import * as RadioGroupRadix from '@radix-ui/react-radio-group';
import PropTypes from 'prop-types';
import './RadioGroup.css';

const RadioGroup = ({ setSelectedRate, items = {}, selectedRate = 0 }) => {
    const onValueChange = (rateIndex) => {
        setSelectedRate(items[rateIndex].id);
    };
    // Find the index of the selectedRate in the items array
    const defaultIndex = items.findIndex((item) => item?.id === selectedRate);
    return (
        <div>
            <RadioGroupRadix.Root
                className="ab-RadioGroupRoot-Gen"
                onValueChange={onValueChange}
                defaultValue={defaultIndex !== -1 ? defaultIndex : 0}
                value={defaultIndex !== -1 ? defaultIndex : 0}
            >
                {/* Do not show the first rate as it is the one that is displayed by default */}
                {items.map((item, index) => {
                    return (
                        <div
                            // className={`ab-room-extra-offer ${
                            //     !isAvailable ? 'not-available' : ''
                            // }`}
                            key={index}
                            className={`ab-radio-wrapper ${
                                item?.noClick && 'ab-no-click'
                            }`}
                        >
                            <RadioGroupRadix.Item
                                className="ab-RadioGroupItem-Gen"
                                value={index}
                                id={item?.id}
                            >
                                <RadioGroupRadix.Indicator className="ab-RadioGroupIndicator-Gen" />
                            </RadioGroupRadix.Item>
                            <label htmlFor={item.id}>
                                {typeof item.label === 'function' ? (
                                    <item.label />
                                ) : (
                                    item?.label
                                )}
                            </label>
                        </div>
                    );
                })}
            </RadioGroupRadix.Root>
        </div>
    );
};

RadioGroup.propTypes = {
    setSelectedRate: PropTypes.func,
    items: PropTypes.array,
    selectedRate: PropTypes.number,
};

export default RadioGroup;
